module.exports = __webpack_public_path__ + "static/media/calendar.be194f98.svg";